import styled from "styled-components";

export const BannerContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  height: ${({ small }) => {
    if (small) return "150px;";
    else return "324px;";
  }};
  background-image: url("/assets/page-banner-bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  text-align: left;
  margin-top: 10px;
`;
export const TitleBox = styled.div`
  width: 585px;
  height: fit-content;
  margin-left: 146px;
  margin-top: 48px;
  margin-bottom: 47px;
`;
export const DescriptionWrapper = styled.div`
  margin-bottom: 31px;
`;
